import { axios } from '@/lib/axios';

export type PropertyFilters = {
  name?: string;
  location?: string;
  minPrice?: string;
  maxPrice?: string;
  page?: number;
  pageSize?: number;
};

export const getAvailableProperties = async (filters?: PropertyFilters) => {
  const cleanParams = filters
    ? Object.fromEntries(
        Object.entries(filters).filter(([, v]) => v !== '' && v != null),
      )
    : {};
  // The backend defaults to a 20-property page and this listing never paged
  // past it — properties beyond the newest 20 were invisible on browse (only
  // findable if you searched by their exact name/location). This is a public
  // storefront, not a paginated log, so show the full catalog.
  const response = await axios.get('/properties/market/available', {
    params: { pageSize: 5000, ...cleanParams },
  });
  return response.data;
};
